import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
import { limitedFilter, limitedBrowsingFilter } from './filters'
const db = firebaseApp.database()

const _1on1sRef = db.ref('1on1s')
const _1on1sDateRef = db.ref('1on1sDate')
const _1on1requestsRef = db.ref('1on1requests')

const drafts1on1sRef = db.ref('drafts/1on1s')

const current1on1sRef = (currentUserId) => { return db.ref('1on1s/' + currentUserId) }
const current1on1sDateRef = (currentUserId) => { return db.ref('1on1sDate/' + currentUserId) }
const current1on1requestsRef = (currentUserId) => { return db.ref('1on1requests/' + currentUserId) }
const currentDrafts1on1sRef = (currentUserId) => { return db.ref('drafts/1on1s/' + currentUserId) }

export const onesModule = {
  namespaced: true,
  state: {
    _1on1s: {},
    _1on1sDate: {},
    _1on1requests: {},
    drafts1on1s: {},
    current1on1s: {},
    current1on1sDate: {},
    current1on1requests: {},
    currentDrafts1on1s: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_1ON1S]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_1ON1S')
      bindFirebaseRef('_1on1s', _1on1sRef, { wait: true })
    }),
    [getterConstants.GET_1ON1S_REQUESTS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_1ON1S_REQUESTS')
      bindFirebaseRef('_1on1requests', _1on1requestsRef, { wait: true })
    }),
    [getterConstants.GET_1ON1S_DATE]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_1ON1S_DATE')
      bindFirebaseRef('_1on1sDate', _1on1sDateRef, { wait: true })
    }),
    [getterConstants.GET_DRAFTS_1ON1S]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_DRAFTS_1ON1S')
      bindFirebaseRef('drafts1on1s', drafts1on1sRef, { wait: true })
    }),
    [getterConstants.GET_CURRENT_1ON1S]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_1ON1S', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('current1on1s', current1on1sRef(currentUserId), { wait: true })
    }),
    [getterConstants.GET_CURRENT_1ON1S_REQUESTS]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_1ON1S_REQUESTS', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('current1on1requests', current1on1requestsRef(currentUserId), { wait: true })
    }),
    [getterConstants.GET_CURRENT_1ON1S_DATE]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_1ON1S_DATE', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('current1on1sDate', current1on1sDateRef(currentUserId), { wait: true })
    }),
    [getterConstants.GET_CURRENT_DRAFTS_1ON1S]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_DRAFTS_1ON1S', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentDrafts1on1s', currentDrafts1on1sRef(currentUserId), { wait: true })
    }),
    [getterConstants.SET_NEW_ONE]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      if (!value.itemId) {
        console.log('!value.itemId')
        const new1on1sRef = _1on1sRef.child(currentUserId).push()
        new1on1sRef.set(value)
      } else {
        const edit1on1sRef = db
          .ref('1on1s/' + currentUserId + '/')
          .child(value.itemId)
        edit1on1sRef.update(value.item)
      }
    }),
    [getterConstants.SET_NEW_ONEDATE]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const new1on1sDate = _1on1sDateRef.child(currentUserId).child('date/').child(value)
      new1on1sDate.set(1)
    }),
    [getterConstants.REMOVE_ONEDATE]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const remove1on1sDate = _1on1sDateRef.child(currentUserId).child('date/').child(value)
      remove1on1sDate.remove()
    }),
    [getterConstants.SET_ONES_LIKES]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const setLikeRef = db.ref(
        '1on1s/' + value.userId + '/' + value.key + '/likes/' + String(value.contentKey) + '/' + currentUserId
      )
      setLikeRef.set(1)
    }),
    [getterConstants.REMOVE_ONES_LIKES]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const removeLikeRef = db.ref(
        '1on1s/' + value.userId + '/' + value.key + '/likes/' + String(value.contentKey) + '/' + currentUserId
      )
      removeLikeRef.remove()
    }),
    [getterConstants.SET_NEW_SEND_1ON1S]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const newSend1on1sRef = db
        .ref('1on1requests/' + currentUserId + '/send1on1')
        .push()
      newSend1on1sRef.set(value)
      console.log('send1on1', value)
    }),
    [getterConstants.REMOVE_SEND_1ON1S]: firebaseAction((context, value) => {
      const targetSend1on1sRef = db.ref('1on1requests/' + value + '/send1on1')
      targetSend1on1sRef.remove()
    }),
    [getterConstants.REMOVE_GET_1ON1S]: firebaseAction((context, value) => {
      const targetGet1on1sRef = db.ref('1on1requests/' + value + '/get1on1')
      targetGet1on1sRef.remove()
    }),
    [getterConstants.SET_NEW_GET_1ON1S]: firebaseAction((context, value) => {
      const newGet1on1sRef = db
        .ref('1on1requests/' + value.sender + '/get1on1')
        .push()
      newGet1on1sRef.set(value.requestGetInfo)
      console.log('get1on1', value)
    }),
    [getterConstants.SET_DRAFTS_1ON1S]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      console.log(value)
      drafts1on1sRef.child(currentUserId).remove()
      const setDrafts1on1sRef = drafts1on1sRef.child(currentUserId).push()
      setDrafts1on1sRef.set(value)
    }),
    [getterConstants.REMOVE_DRAFTS_1ON1S]: firebaseAction((context, value) => {
      drafts1on1sRef.child(value).remove()
    }),
    [getterConstants.SET_1ON1REQ_LAST_NOTICE]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      console.log('SET_1ON1REQ_LAST_NOTICE:currentUserId', currentUserId)
      if (currentUserId) {
        const setLastNoticeRef = db.ref('1on1requests/' + currentUserId + '/lastNotice')
        setLastNoticeRef.set(value)
        console.log('set 1on1Req:lastNotice::', value)
      } else {
        console.log('not set 1on1Req:lastNotice::')
      }
    })
  },
  getters: {
    get1on1s: state => state._1on1s,
    get1on1sDate: state => state._1on1sDate,
    getDraft1on1s: state => state.drafts1on1s,
    get1on1sRequeest: state => state._1on1requests,
    getCurrent1on1s: state => state.current1on1s,
    getCurrent1on1sDate: state => state.current1on1sDate,
    getCurrent1on1sRequest: state => state.current1on1requests,
    getCurrentDraft1on1s: state => state.currentDrafts1on1s,
    get1on1ById: (state, getters, rootState) => (userId, key, isAdmin, isForceBrowsing) => {
      let state1on1s = null
      if (!!isAdmin || !!isForceBrowsing) {
        state1on1s = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state._1on1s)[userId]
      } else {
        state1on1s = limitedFilter(rootState.currentUserId, rootState.currentUser, state._1on1s)[userId]
      }
      return state1on1s[key] ? state1on1s[key] : {}
    },
    get1on1sByUserId: (state, getters, rootState) => (userId, isAdmin, isForceBrowsing) => {
      let state1on1s = null
      if (!!isAdmin || !!isForceBrowsing) {
        state1on1s = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state._1on1s)
      } else {
        state1on1s = limitedFilter(rootState.currentUserId, rootState.currentUser, state._1on1s)
      }
      return state1on1s[userId] ? state1on1s[userId] : {}
    },
    get1on1RequestsByUserId: (state, getters, rootState) => (userId, isAdmin, isForceBrowsing) => {
      let state1on1Requests = null
      if (!!isAdmin || !!isForceBrowsing) {
        state1on1Requests = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state._1on1requests)
      } else {
        state1on1Requests = limitedFilter(rootState.currentUserId, rootState.currentUser, state._1on1requests)
      }
      return state1on1Requests[userId] ? state1on1Requests[userId] : {}
    },
    getCurrent1on1RequestsReceivedUnread: state => {
      const current1on1Requests = state.current1on1requests
      const lastNotice = current1on1Requests.lastNotice || 0
      let unread = []
      // console.log('getCurrent1on1RequestsReceivedUnread:', { current1on1Requests: current1on1Requests, lastNotice: lastNotice, unread: unread })
      if (current1on1Requests.get1on1) {
        for (let k of Object.keys(current1on1Requests.get1on1)) {
          let req = current1on1Requests.get1on1[k]
          // console.log('current1on1Requests:get1on1', req)
          if ((req.createdAt || 0) > lastNotice) {
            // console.log('unread!!!:', k)
            req.itemId = k
            unread.push(req)
          } else {
            // console.log('read:', k)
          }
        }
      }
      return unread
    },
    getIsReadLike: (state, getters, rootState) => (targetOwner, targetItem, likeOwner, count) => {
      let like
      try {
        like = rootState.readTimes['likes']['1on1s_' + String(count)][targetOwner][targetItem][likeOwner]
      } catch (e) {
        return false
      }
      return !!like
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/ones.js